import React from 'react';
import classNames from 'classnames';
import { Button as AntButton } from 'antd';
import './Button.scss';

export default ({ secondary = false, type = null, className, ...rest }) => (
  <AntButton type={type} className={classNames('button', type, className, { secondary })} {...rest} />
);
